import { Divider, Form } from 'antd';
import ButtonsToGenerateReports from '@/components/Reports/ButtonsToGenerateReports';
import { DefaultRouteTabs } from '@/components/_common';
import { PageProps } from '@/types/PageProps';
import { useIntl } from 'react-intl';
import { Helmet } from 'react-helmet';
import HoursCostForm from '@/components/Reports/ProductiveReports/ProductiveHoursCostForm';
import {
  QuestReportHourlyCostRequest,
  QuestReportHourlyFormValues,
} from '@/core/domain/questReport/Reports/HourlyCost/HourlyCost.types';
import { useReportHandlers } from '@/hooks/useReportHandler';
import useFileLoading, { FileType } from '@/hooks/useFileLoading';
import { useHourlyCostReport } from '@/core/domain/questReport/Reports/HourlyCost/HourlyCost.hook';
import { ReportCallback } from '@/hooks/useReportGenerate';
import { QuestResponseType } from '@/core/domain/questReport/Reports/Quotation/Quotation.types';
import { DateTimeFormat } from '@/utils/moment';

function ProductiveHoursCostPage({ route }: PageProps) {
  const intl = useIntl();
  const [form] = Form.useForm<QuestReportHourlyFormValues>();

  const { setFileLoading, setFileUnloading, fileLoading } = useFileLoading();

  const generateReport = useHourlyCostReport();

  const handleGenerateReport = async (
    format: FileType,
    callback?: ReportCallback,
  ) => {
    setFileLoading(format);

    try {
      const values = await form.validateFields();

      const obj: QuestReportHourlyCostRequest = {
        responseType:
          format === 'CSV' ? QuestResponseType.CSV : QuestResponseType.PDF,
        companiesIds: values.companiesIds?.toString(),
        subAreasIds: values.subAreasIds?.toString(),
        employeesIds: values.employeesIds?.toString(),
        filterDateBy: values.filterDateBy,
        costByEmployee: values.costByEmployee,
        situation: values.situation,
        workOrderTypes: values.workOrderTypes,
        startDate: values.initialDate.format(DateTimeFormat),
        endDate: values.finalDate.format(DateTimeFormat),
      };

      const result = await generateReport.mutateAsync(obj);

      if (callback) {
        callback(result);
      }
    } catch {}

    setFileUnloading(format);
  };

  const { handleView, handlePdf, handleCsv } = useReportHandlers(
    'relatorio_custo_da_hora',
    handleGenerateReport,
  );

  return (
    <DefaultRouteTabs route={route.parent} permissions={route.permissions}>
      <Helmet title={intl.formatMessage({ id: route.name })} />

      <HoursCostForm form={form} />

      <Divider />

      <ButtonsToGenerateReports
        viewReport={handleView}
        generatePdf={handlePdf}
        generateCsv={handleCsv}
        loading={fileLoading}
      />
    </DefaultRouteTabs>
  );
}
export default ProductiveHoursCostPage;
